
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/learn/search/[...segments]",
      function () {
        return require("private-next-pages/learn/search/[...segments]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/learn/search/[...segments]"])
      });
    }
  